/* Extracted behavior from sections/basic-faq.liquid.
   Delegation keeps Shopify theme-editor section reloads idempotent. */
(function () {
  'use strict';

  if (window.__basicHomeFaqBound) return;
  window.__basicHomeFaqBound = true;

  document.addEventListener('click', function (event) {
    var target = event.target;
    var btn = target && target.closest ? target.closest('[data-basic-faq] .bfaq-filter') : null;
    if (!btn) return;

    var root = btn.closest('[data-basic-faq]');
    if (!root) return;

    var cat = btn.getAttribute('data-cat');
    var filters = root.querySelectorAll('.bfaq-filter');
    var groups = root.querySelectorAll('.bfaq-group');

    filters.forEach(function (filter) {
      filter.classList.toggle('active', filter === btn);
    });
    groups.forEach(function (group) {
      if (cat === 'all' || group.getAttribute('data-group') === cat) {
        group.removeAttribute('hidden');
      } else {
        group.setAttribute('hidden', '');
      }
    });
  });
})();

